<template>
  <footer class="brand-footer">
    <img class="brand-footer__sunset" src="/assets/brand/desert-sunset.png" alt="" />
    <div class="brand-footer__inner">
      <div class="brand-footer__mark">
        <img src="/assets/brand/wordmark-cream.svg" alt="Banjino's" />
        <img class="brand-footer__pear" src="/assets/brand/pricklypear.png" alt="" />
      </div>
      <p class="brand-footer__legal">
        SHIPPED WITHIN TEXAS · AN ADULT 21+ SIGNS AT DELIVERY<br />
        YOU MUST BE 21 OR OLDER TO PURCHASE · PLEASE ENJOY RESPONSIBLY
      </p>
    </div>
  </footer>
</template>

<style scoped>
.brand-footer {
  position: relative;
  background: var(--bj-green-dark);
  overflow: hidden;
}

.brand-footer__sunset {
  position: absolute;
  left: 50%;
  bottom: -60px;
  transform: translateX(-50%);
  width: 1440px;
  max-width: none;
  opacity: 0.3;
  pointer-events: none;
}

.brand-footer__inner {
  position: relative;
  padding: 56px 64px 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
}

.brand-footer__mark { display: flex; align-items: center; gap: 34px; }
.brand-footer__mark img { height: 48px; display: block; }
.brand-footer__pear { height: 64px !important; opacity: 0.75; }

.brand-footer .brand-footer__legal {
  margin: 0;
  font-family: var(--bj-font-ui) !important;
  font-size: 11px;
  line-height: 2.1;
  letter-spacing: 0.08em;
  color: var(--bj-tan);
  text-align: right;
}

@media (max-width: 600px) {
  .brand-footer__inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 28px;
    padding: 40px 24px 36px;
  }
  .brand-footer__mark img { height: 38px; }
  .brand-footer__pear { height: 52px !important; }
  .brand-footer .brand-footer__legal { text-align: left; }
  .brand-footer__sunset { width: 900px; bottom: -30px; }
}
</style>
